// module.exports = require('./src')
import Pay from './src/index'
export default Pay
